<template>
    <div class="breadcrumb">
        <router-link to="mixology" target="_self"><custom-icon class="btn-arrow" :link="Arrow"></custom-icon>back to recipes page</router-link>
        <router-view />
    </div>
</template>

<script>
import Arrow from "./../../assets/mixology/icons/arrow.svg";
import CustomIcon from "@/components/custom-icons/Icon";

export default {

    name: "bread-crumb",
    components: {
        CustomIcon,
        Arrow,
    },
    data() {
      return {
        Arrow,
      };
    },
}
</script>

<style lang="scss">

        .breadcrumb {
            flex: 1 0 100%;
            text-align: right;

            a {
                position: relative;
                overflow: hidden;
                display: inline-block;
                margin: 2em 0 3em;
                line-height: 18px;
                font-size: 12px;
                font-weight: normal;
            }

            svg.btn-arrow {
                width: 18px;
                height: 18px;
                margin: 0 0.75em 0 0;
                fill: #fff;
                -webkit-transform: rotate(90deg);
                transform: rotate(90deg);
                -webkit-transition: -webkit-transform .3s ease-in-out;
                transition: transform .3s ease-in-out; 
                vertical-align: top;
            }

            a:hover svg.btn-arrow  {
                -webkit-transform: rotate(450deg);
                transform: rotate(450deg);
                    
            }
        }
        [class^="bounce"] {
            .breadcrumb a {
                padding: 1rem;
            }
        }

</style>


// WEBPACK FOOTER //
// src/components/mixology/BreadCrumb.vue